@use 'sass:math';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/breakpoints.variables' as breakpoints;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/fonts.variables' as fonts;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/4-elements/_global.elements.scss';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/5-layout/_grid.layout.scss';
@forward 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/7-overrides/spacing.overrides.scss';

$ontario-icon-size--social-large: 36px;
$ontario-icon-size--social-small: 32px;

.ontario-footer {
	color: colours.$ontario-colour-white;
	margin-top: spacing.$spacing-10;
	padding: spacing.$spacing-9 spacing.$spacing-0;
}

.ontario-footer .ontario-columns {
	*:last-child {
		margin-bottom: spacing.$spacing-0;
	}

	@media screen and (max-width: breakpoints.$medium-breakpoint) {
		margin-bottom: spacing.$spacing-8;

		&:last-of-type {
			margin-bottom: spacing.$spacing-0;
		}
	}
}

.ontario-footer__links-container {
	list-style: none;
	margin: spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-4 spacing.$spacing-0;

	@media screen and (min-width: breakpoints.$medium-breakpoint) {
		margin-bottom: spacing.$spacing-2;
	}
}

.ontario-footer__links-container--inline {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		flex-direction: row;
	}
}

/*************************************
    Expanded footer specific styles
**************************************/

.ontario-footer__links-container--two-column-list {
	column-count: 1;
	display: block;
	margin: spacing.$spacing-0;

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		column-count: 2;

		.ontario-footer__link {
			padding: spacing.$spacing-0;
			margin: spacing.$spacing-0 spacing.$spacing-4 spacing.$spacing-4 spacing.$spacing-0;
		}
	}
}

.ontario-footer__links-container li {
	padding: spacing.$spacing-1 spacing.$spacing-0;
}

.ontario-footer__link {
	color: colours.$ontario-colour-white;
	display: inline-block;
	padding: spacing.$spacing-2 spacing.$spacing-0;
	margin: spacing.$spacing-0;
	text-decoration: underline;

	&:hover,
	&:focus {
		text-decoration: none;
	}

	&:visited,
	&:active,
	&:hover {
		color: colours.$ontario-colour-white;
	}

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		padding: spacing.$spacing-0;
		margin: spacing.$spacing-0 spacing.$spacing-8 spacing.$spacing-4 spacing.$spacing-0;
	}
}

.ontario-footer__copyright a {
	margin: spacing.$spacing-0;
}

.ontario-footer__links-container--social {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.ontario-footer__links-container--social .ontario-footer__link {
	background: transparent;
	border-radius: 45%;
	margin: spacing.$spacing-0 spacing.$spacing-4 spacing.$spacing-3 spacing.$spacing-0;
	padding: spacing.$spacing-0;
	outline: none;

	height: (spacing.$spacing-8 + spacing.$spacing-2);
	width: (spacing.$spacing-8 + spacing.$spacing-2);

	display: flex;
	justify-content: center;
	align-items: center;

	&:hover,
	&:focus {
		background-color: darken(colours.$ontario-colour-white, 100);

		.ontario-icon {
			fill: colours.$ontario-colour-white;
		}
	}

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		height: spacing.$spacing-8;
		width: spacing.$spacing-8;
	}
}

.ontario-footer__links-container--social .ontario-footer__link .ontario-icon {
	fill: colours.$ontario-colour-white;
	width: $ontario-icon-size--social-large;
	height: $ontario-icon-size--social-large;

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		width: $ontario-icon-size--social-small;
		height: $ontario-icon-size--social-small;
	}
}

.ontario-footer__paragraph {
	max-width: globalVariables.$standard-width;
	width: globalVariables.$full-width;
	margin-bottom: spacing.$spacing-5;
}

.ontario-footer p,
.ontario-footer__paragraph,
.ontario-footer__list_item {
	a {
		color: colours.$ontario-colour-white;
		font-weight: fontWeights.$ontario-font-weights-semi-bold;

		&:visited {
			color: colours.$ontario-colour-white;
		}

		&:active {
			color: darken(colours.$ontario-colour-white, 10);
		}

		&:focus,
		&:hover {
			text-decoration: none;
		}
	}
}

.ontario-button.ontario-footer__button {
	background-color: colours.$ontario-colour-black;
	border: 2px solid colours.$ontario-colour-white;
	border-color: colours.$ontario-colour-white;
	color: colours.$ontario-colour-white;
	margin-bottom: spacing.$spacing-6;
	border-radius: spacing.$spacing-1;
	box-sizing: border-box;
	box-shadow: none;
	display: inline-block;
	font-size: 1.125rem;
	font-family: fonts.$ontario-font-open-sans;
	font-weight: fontWeights.$ontario-font-weights-semi-bold;
	line-height: math.div(14, 9);
	margin: 0 (1rem + 0.75rem) 1.5rem 0;
	min-width: 10rem;
	padding: 0.625rem 1.5rem;
	text-align: center;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		background-color: darken(colours.$ontario-colour-white, 70);
	}

	&:focus,
	&:active {
		background-color: darken(colours.$ontario-colour-white, 60);
		box-shadow: 0 0 0 spacing.$spacing-1 colours.$ontario-colour-focus;
		outline: spacing.$spacing-1 solid transparent;
		transition: all 0.1s ease-in-out;
	}
}

.ontario-footer__button + .ontario-footer__links-container {
	margin-top: spacing.$spacing-5;
}

/* Supergraphic background */
.ontario-footer--default,
.ontario-footer__expanded-top-section {
	position: relative;

	&:before {
		background-color: darken(colours.$ontario-colour-white, 80);
		background-repeat: no-repeat;
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: globalVariables.$full-width;
		height: 100%;
	}
}

// Use CSS variable for optional background override.
// Default to `none`, since the actual image is set via component logic.
// Avoid using `url("")`, which triggers build warnings.
.ontario-footer--default:before {
	background-image: var(--imagePath, none);
}

.ontario-footer__expanded-top-section:before {
	background-image: var(--imagePath, none);
}

//////////////////////////
//  Footer variations  //
/////////////////////////

/* Default footer */
.ontario-footer--default {
	background-color: colours.$ontario-colour-black;
	border-bottom: spacing.$spacing-1 solid colours.$ontario-greyscale-70;

	&:before {
		background-size: 112.5rem;
		background-position: calc(50vw - 73.5rem) -64rem;

		@media screen and (min-width: breakpoints.$small-breakpoint) {
			background-size: 180rem;
			background-position: calc(50vw - 120rem) -106rem;
		}

		@media screen and (min-width: breakpoints.$medium-breakpoint) {
			background-size: 275rem;
			background-position: calc(50vw - 187rem) -160rem;
		}
	}
}

/* expanded footer */
.ontario-footer--expanded {
	padding-top: spacing.$spacing-0;
	background-color: colours.$ontario-colour-black;
	border-bottom: spacing.$spacing-1 solid colours.$ontario-greyscale-70;
}

.ontario-footer__expanded-top-section {
	background-color: darken(colours.$ontario-colour-white, 85);
	padding: spacing.$spacing-9 spacing.$spacing-0;

	&:before {
		background-size: 165rem;
		background-position: calc(50vw - 125rem) -64rem;

		@media screen and (min-width: breakpoints.$small-breakpoint) {
			background-size: 250rem;
			background-position: calc(50vw - 195rem) -106rem;
		}

		@media screen and (min-width: breakpoints.$medium-breakpoint) {
			background-size: 305rem;
			background-position: calc(50vw - 222rem) -160rem;
		}
	}
}

.ontario-footer__expanded-top-section .ontario-footer__link {
	text-decoration: underline;

	&:hover,
	&:focus {
		text-decoration: none;
	}

	&:active {
		color: darken(colours.$ontario-colour-white, 10);
	}
}

.ontario-footer__expanded-top-section ul {
	margin-bottom: spacing.$spacing-0;
}

.ontario-expanded-footer__one-third-block {
	margin-bottom: spacing.$spacing-0;

	&:first-of-type,
	&:nth-child(2) {
		margin-bottom: spacing.$spacing-8;
	}

	@media screen and (min-width: breakpoints.$small-breakpoint) {
		margin-bottom: spacing.$spacing-0;

		&:first-of-type {
			margin-bottom: spacing.$spacing-8;
		}

		&:nth-child(2) {
			margin-bottom: spacing.$spacing-0;
		}
	}

	@media screen and (min-width: breakpoints.$medium-breakpoint) {
		margin-bottom: spacing.$spacing-0;

		&:first-of-type {
			margin-bottom: spacing.$spacing-0;
		}
	}
}

.ontario-footer__expanded-bottom-section {
	background-color: colours.$ontario-colour-black;
	padding-top: spacing.$spacing-9;
}
